import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Form, FormComponent } from 'core/form';
import { fields, options } from 'app/forms/config/mitigationMethod';
import formConsumer from 'core/form/formConsumer';
import MethodFlowspec from 'app/views/settings/mitigations/methods/MethodFlowspec';
import storeLoader from 'app/stores/storeLoader';
import Spinner from 'core/components/Spinner';
import Suspense from 'core/components/Suspense';

// just an intermediary component to adhere to form structure and form wrapper requirements
@formConsumer
class FlowspecMethodSummaryForm extends Component {
  render() {
    return <MethodFlowspec infoMode {...this.props} />;
  }
}

@Form({ fields, options })
@storeLoader('$mitigations.methodsCollection', '$mitigations.platformsCollection', '$alerting.policyCollection')
@inject('$devices')
@observer
// eslint-disable-next-line react/no-multi-comp
export default class FlowspecMethodSummary extends Component {
  render() {
    const {
      $mitigations,
      alertModel,
      mitigation,
      useNameAsTitle,
      showViewInDataExplorerButton,
      mitigationContext,
      title,
      minimal = false,
      wrap = false
    } = this.props;

    const loading = $mitigations.platformsCollection.loading || $mitigations.methodsCollection.loading;
    const method = !loading && $mitigations.methodsCollection.get(mitigation.id || mitigation.methodID.getValue());

    return (
      <Suspense loading={!method} fallback={<Spinner size={24} />}>
        <FormComponent fields={fields} options={options} model={method}>
          <FlowspecMethodSummaryForm
            useNameAsTitle={useNameAsTitle}
            showViewInDataExplorerButton={showViewInDataExplorerButton}
            mitigationContext={mitigationContext}
            alertModel={alertModel}
            minimal={minimal}
            title={title}
            wrap={wrap}
          />
        </FormComponent>
      </Suspense>
    );
  }
}
